import { useTranslation } from 'react-i18next';

import CourseLessonsHeader from '@/components/course-progress/CourseLessonsHeader';
import ApiErrorFallback from '@/components/shared/ApiErrorFallback';
import ActiveCourseSelect from '@/components/student-dashboard/ActiveCourseSelect';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useStudentDashboard } from '@/data/context/StudentDashboardContext';
import useShellBackHref from '@/data/hook/app-shell/useShellBackHref';
import { ROUTES } from '@/utils/routes';
import StudentUnitSection from './StudentUnitSection';
import UnitList from './UnitList';

export default function StudentCourseLessonsView() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'errors.errorPage.courseNotFound',
  });
  const { activeCourseProgress, isLoading, error } = useStudentDashboard();
  const isCourseNotFound = !isLoading && !error && !activeCourseProgress;
  useShellBackHref(ROUTES.DASHBOARD.BASE);

  return (
    <div className="flex flex-col shrink-0 gap-4 min-h-full">
      <CourseLessonsHeader actions={<ActiveCourseSelect />} />
      <section className="flex flex-1 flex-col gap-6 rounded-2xl">
        <UnitList
          slug={activeCourseProgress?.coursePath.slug}
          isLoading={isLoading}
        >
          {(unit, index) =>
            activeCourseProgress && (
              <StudentUnitSection
                key={unit.id}
                unit={unit}
                defaultOpen={index === 0}
                courseProgress={activeCourseProgress}
              />
            )
          }
        </UnitList>
        <ConditionalRenderer condition={!!error || isCourseNotFound}>
          <ApiErrorFallback
            error={error}
            notFoundTitle={t('title')}
            notFoundSubtitle={t('subtitle')}
          />
        </ConditionalRenderer>
      </section>
    </div>
  );
}
